import { render, staticRenderFns } from "./protocol-item.vue?vue&type=template&id=202b29aa&scoped=true"
import script from "./protocol-item.vue?vue&type=script&lang=ts"
export * from "./protocol-item.vue?vue&type=script&lang=ts"
import style0 from "./protocol-item.vue?vue&type=style&index=0&id=202b29aa&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202b29aa",
  null
  
)

export default component.exports